import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-percent-range',
    templateUrl: './percent-range.component.html',
    styleUrls: ['./percent-range.component.scss'],
})
export class PercentRangeComponent {
    @Input() percent = null;
    @Input() label: string;
    @Input() disabled: boolean = false;
    @Output() percentChange = new EventEmitter<string>();

    onIonChange(event) {
        this.percentChange.emit(event.detail.value);
    }
}
